import { render } from "./FeaturesCheckBox.vue?vue&type=template&id=2e6bbf56"
import script from "./FeaturesCheckBox.vue?vue&type=script&lang=js"
export * from "./FeaturesCheckBox.vue?vue&type=script&lang=js"

import "./FeaturesCheckBox.vue?vue&type=style&index=0&id=2e6bbf56&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__